import { render, staticRenderFns } from "./VideoProfile.vue?vue&type=template&id=1274530c&scoped=true"
import script from "./VideoProfile.vue?vue&type=script&setup=true&lang=ts"
export * from "./VideoProfile.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./VideoProfile.vue?vue&type=style&index=0&id=1274530c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1274530c",
  null
  
)

export default component.exports